'use client'

import { FC } from 'react'

import Link from 'next/link'

import { Logo } from '@dfds-pax/shared-components/client'

import { useBasket } from '@/providers/basket-context'

interface Props {
  ferry: string
  locale: string
  variant: 'light' | 'dark'
}

const FrMaLogo: FC<Omit<Props, 'locale'>> = ({ ferry, variant }) => {
  const { basket } = useBasket()

  return (
    <Link href={`/fr-ma/${ferry}`} prefetch={false}>
      <Logo variant={variant} isRfs={basket?.priceStructure.currency === 'MAD'} />
    </Link>
  )
}

const LogoWrapper: FC<Props> = ({ ferry, locale, variant }) => {
  if (locale !== 'fr-ma') {
    return (
      <Link href={`/${locale}/${ferry}`} prefetch={false}>
        <Logo variant={variant} />
      </Link>
    )
  }

  return <FrMaLogo ferry={ferry} variant={variant} />
}

export default LogoWrapper
